// extracted by mini-css-extract-plugin
export default {"button":"button_button__ktA4d","primary":"button_primary__vau7k","disabled":"button_disabled__Xp+DF"};